import { FC, useEffect, useRef, useState } from "react";

type TimeCountdownProps = {
  dateTo: Date;
  className?: string;
  expiredClassName?: string;
};

const TimeCountdownComponent: FC<TimeCountdownProps> = (props) => {
  const [timeString, setTimeString] = useState("");
  const [isExpired, setIsExpired] = useState(false);
  const timeCountdownInterval = useRef<NodeJS.Timeout | null>(null);

  const formatNumber = (number: number): string => {
    return `${number}`.padStart(2, "0");
  };

  const createTimeString = (timeLeft: number): string => {
    const format = "hh:mm:ss";

    if (timeLeft < 0) {
      const dateAsString = format
        .replace(`hh`, "00")
        .replace(`mm`, "00")
        .replace(`ss`, "00");

      return dateAsString;
    }

    const seconds = (timeLeft / 1000) % 60;
    const minutes = (timeLeft / 1000 / 60) % 60;
    const hours = timeLeft / 1000 / 60 / 60;

    const dateAsString = format
      .replace(`hh`, formatNumber(Math.floor(hours)))
      .replace(`mm`, formatNumber(Math.floor(minutes)))
      .replace(`ss`, formatNumber(Math.floor(seconds)));

    return dateAsString;
  };

  const computeAndSetTimeString = () => {
    const timeLeft = new Date(props.dateTo).getTime() - new Date().getTime();

    const timeString = createTimeString(timeLeft);

    setTimeString(timeString);

    if (timeLeft < 1000) {
      setIsExpired(true);

      if (timeCountdownInterval.current)
        clearInterval(timeCountdownInterval.current);
    }
  };

  useEffect(() => {
    computeAndSetTimeString();

    timeCountdownInterval.current = setInterval(computeAndSetTimeString, 1000);

    return () => {
      if (timeCountdownInterval.current)
        clearInterval(timeCountdownInterval.current);
    };
  }, []);

  const className = (isExpired && props.expiredClassName) || props.className;

  return <div className={className}>{timeString}</div>;
};

export default TimeCountdownComponent;
